import {
    closeArchiveJob, closeCloseJob, closeCopyJob, closeEditJobAddress, closeEditJobAppt, closeEditJobClient, closeEditJobDetails,
    closeEditJobTech, closeInvalidCloseJob, closeJobQuickView, closeNewChatModal, closenotCalledActions, closeReopenJob, closeSendJob, closeAttachmentsJob, closeTechQuickView, editJobPaymentClose, openCloseJob, reloadOpenedJob, useGlobal
} from "../../../../../core/Global"
import NewChatModal from "../../../../chat/components/NewChatModal"
import JobAppointmentModal from "./JobAppointmentModal"
import JobClientEdit from "./JobClientEdit"
import JobDetailsEdit from "./JobDetailsEdit"
import JobDrawerView from "../JobDrawerView"
import JobReopenFromClosedModal from "../JobReopenFromClosedModal"
import JobSendModal from "./JobSendModal"
import JobsListModal from "./JobsListModal"
import JobArchiveModal from "./JobArchiveModal"
import JobCloseNotValidModal from "./JobCloseNotValidModal"
import JobClosePaymentModal from "./JobClosePaymentModal"
import JobUpdateTechModal from "./JobUpdateTechModal"
import JobUpdateAddressModal from "./JobUpdateAddressModal"
import JobNotCalledActionsModal from "./JobNotCalledActionsModal"
import JobDeleteModal from "./JobDeleteModal"
import ContactJobsListModal from "./ContactJobsListModal"
import ModalTechCalendar from "../../../../../components/modals/ModalTechCalendar"
import JobRejectByTechModal from "./JobRejectByTechModal"
import JobFormDrawer from "../../views/JobFormDrawer"
import MobileJobInvoicesList from "../mobile/MobileJobInvoicesList"
import MobileJobInvoiceView from "../mobile/MobileJobInvoiceView"
import JobAttachmentsModal from "./JobAttachmentsModal"
import TechDrawerView from "../../../../../components/tech/TechDrawerView"





export default function JobGlobalModals() {

    const [globalState] = useGlobal()

    return (
        <>

            {globalState.reportListModal && <JobsListModal list={globalState.reportListModal} />}

            {globalState.contactJobsPhone && <ContactJobsListModal phone={globalState.contactJobsPhone} />}

            {
                globalState.createJob &&
                <JobFormDrawer duplicateId={globalState.duplicateJobId}
                    chatMessageId={globalState.messageToJobId}
                    liveCallRefId={globalState.liveCallJobRefId}
                    prefillPhone={globalState.createJobPrefillPhone}
                    prefillJobSourceId={globalState.createJobPrefillJobSourceId} />
            }

            {
                globalState.techQuickView &&
                <TechDrawerView id={globalState.techQuickView} onSelect={globalState.techQuickViewSelect} onClose={closeTechQuickView} />
            }

            {
                globalState.quickJobView &&
                <JobDrawerView id={globalState.quickJobView}
                    tab={globalState.quickJobTab ?? "1"}
                    onClose={closeJobQuickView}
                />
            }

            {
                globalState.editJobClient &&
                <JobClientEdit job={globalState.editJobClient} onClose={closeEditJobClient} />
            }

            {
                globalState.editJobAppt &&
                <JobAppointmentModal job={globalState.editJobAppt} onClose={closeEditJobAppt} />
            }

            {
                globalState.sendJob &&
                <JobSendModal job={globalState.sendJob} onClose={closeSendJob} />
            }

            {
                globalState.copyJob &&
                <JobSendModal job={globalState.copyJob} onClose={closeCopyJob} justCopy />
            }

            {
                globalState.editJobTech &&
                <JobUpdateTechModal job={globalState.editJobTech} onClose={closeEditJobTech} />
            }

            {
                globalState.editJobAddress &&
                <JobUpdateAddressModal job={globalState.editJobAddress} onClose={closeEditJobAddress} />
            }

            {
                globalState.editJobDetails &&
                <JobDetailsEdit job={globalState.editJobDetails} onClose={closeEditJobDetails} />
            }

            {
                globalState.archiveJob &&
                <JobArchiveModal job={globalState.archiveJob} onClose={closeArchiveJob} />
            }

            {
                globalState.invalidCloseJob &&
                <JobCloseNotValidModal job={globalState.invalidCloseJob} error={globalState.invalidCloseErrs}
                    onClose={closeInvalidCloseJob}
                    onUpdate={job => {
                        setTimeout(() => {
                            openCloseJob(job)
                        }, 500);
                    }} />
            }

            {
                globalState.closeJob &&
                <JobClosePaymentModal jobId={globalState.closeJob.id}
                    onClose={closeCloseJob}
                />
            }

            {
                globalState.reopenJob &&
                <JobReopenFromClosedModal job={globalState.reopenJob} status={globalState.reopenToStatus}
                    onClose={closeReopenJob} />
            }


            {
                globalState.notCalledActions &&
                <JobNotCalledActionsModal job={globalState.notCalledActions}
                    onClose={closenotCalledActions} />
            }

            {
                globalState.deleteJob &&
                <JobDeleteModal job={globalState.deleteJob} />
            }

            {
                globalState.editJobPayment &&
                <JobClosePaymentModal jobId={globalState.editJobPayment.id} editMode
                    onClose={() => editJobPaymentClose()}
                    onUpdate={reloadOpenedJob} />
            }

            {
                globalState.techIdCalendar && <ModalTechCalendar />
            }

            {
                globalState.rejectJobByTech && <JobRejectByTechModal job={globalState.rejectJobByTech} />
            }


            {
                globalState.invoicesJob && <MobileJobInvoicesList job={globalState.invoicesJob} />
            }

            {
                globalState.invoicesJob && globalState.invoiceJobView?.id && <MobileJobInvoiceView job={globalState.invoicesJob} invoiceId={globalState.invoiceJobView.id} />
            }

            {
                globalState.attachmentsJob &&
                <JobAttachmentsModal job={globalState.attachmentsJob} onClose={closeAttachmentsJob} />
            }

            {
                globalState.newChatModal &&
                <NewChatModal
                    prefillPhone={globalState.newChatModal.phone}
                    onClose={closeNewChatModal}
                />
            }


        </>
    )
}